import React, {useEffect, useState} from "react";
import {MyBreadcrumb, UserApplicationItem} from "../../../components";
import {Col, Row} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {selectStore} from "../../../store/selector";
import {fetchEntrantApplicationsAction} from "../../../store/pages/admission/actions";
import {
    UserApplicationBreadcrumb
} from "../../../components/pages/Entrant/ExecutorApplication/UsetApplication/UserApplicationBreadcrumb";
import {useSearchParams} from "react-router-dom";

export const UserApplications = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("educationOrders");
    const [searchParams, setSearchParams] = useSearchParams();

    const tabParams = searchParams.get('tab')

    const [currentTab, setCurrentTab] = useState("1")

    useEffect(() => {
        dispatch(fetchEntrantApplicationsAction());

        if(tabParams){
            setCurrentTab(tabParams)
        }

        //eslint-disable-next-line
    }, [])

    const { admission: {entrantApplications} } = useSelector(selectStore);

    const filterFunc = () => {
        switch (currentTab) {
            case "1":
                //@ts-ignore
                let filteredData = entrantApplications.data.filter((educationOrder:any) => educationOrder.status === "0")

                return filteredData.sort((a:any, b:any) => a.id < b.id ? 1 : -1)
            case "2":
                //@ts-ignore
                let filteredDataAccepted = entrantApplications.data.filter((educationOrder:any) => educationOrder.status === "2")

                return filteredDataAccepted.sort((a:any, b:any) => a.id < b.id ? 1 : -1)
            case "3":
                //@ts-ignore
                let filteredDataRejected = entrantApplications.data.filter((educationOrder:any) => educationOrder.status === "3" || educationOrder.status === "5")

                return filteredDataRejected.sort((a:any, b:any) => a.id < b.id ? 1 : -1)
            default:
                return []
            case "4":
                //@ts-ignore
                let filteredDataDrafts = entrantApplications.data.filter((educationOrder:any) => !educationOrder.status)

                return filteredDataDrafts.sort((a:any, b:any) => a.id < b.id ? 1 : -1)
        }
    }

    return(
        <>
            <UserApplicationBreadcrumb setCurrentTab={setCurrentTab} educationOrders={entrantApplications} title={t("userApplications")} currentTab={currentTab}/>

            <Row justify='center'>
                <Col span={20}>
                    <Row>
                        <Col span={24} style={{marginTop: 16}}>
                            {entrantApplications.success && entrantApplications.data && filterFunc().map((educationOrder: any, index: number) => (
                                <div key={educationOrder.id + '-' + index} style={{ marginBottom: (entrantApplications!.data.length !== (index + 1)) ? 16 : 0 }}>
                                    <UserApplicationItem number={educationOrder.id} title={t("userApplication")}
                                                         status={educationOrder.status}

                                        //@ts-ignore
                                                         date={educationOrder.created_at}/>
                                </div>
                            ))}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}